import { getSeedContent } from '@/lib/seed-content';
import { presetsForUnitType } from '@/lib/site-styles/theme-presets';
import type { UnitType } from '@/types/database';
import type { SiteTemplate } from './types';

// Every unit type src/lib/seed-content.ts has real content for — see
// docs/site-builder-overhaul.md's design-system pass (UnitType used to
// only expose 2 of these 9).
const SUPPORTED_UNIT_TYPES: UnitType[] = [
  'cub_scout_pack',
  'scouts_bsa_troop',
  'venturing_crew',
  'sea_scout_ship',
  'exploring_post',
  'exploring_club',
  'girl_scout_troop',
  'trail_life_troop',
  'ahg_troop',
];

// Two templates per unit type, both reusing real Site Styles presets
// rather than duplicating palette/font values here — a template is
// content (seed pages) paired with a preset a unit could just as well
// apply on its own later from the Themes gallery. The first is whichever
// preset presetsForUnitType() puts first (the program's own dedicated,
// on-brand preset for the 4 core Scouting America youth programs; a
// generic preset otherwise), the second is always a generic preset for
// contrast.
function templatesForUnitType(unitType: UnitType): SiteTemplate[] {
  const [primary, secondary] = presetsForUnitType(unitType);
  return [primary, secondary].map((preset) => ({
    id: `${preset.id}-${unitType}`,
    name: preset.name,
    description: preset.description,
    unitTypes: [unitType],
    theme: preset.config,
    buildPages: (unitName: string, unitIdentifier: string) => getSeedContent(unitType, unitName, unitIdentifier),
  }));
}

export const templateCatalog: SiteTemplate[] = SUPPORTED_UNIT_TYPES.flatMap(templatesForUnitType);

export function getTemplatesForUnitType(unitType: UnitType | null | undefined): SiteTemplate[] {
  if (!unitType) return templateCatalog;
  const matches = templateCatalog.filter((template) => template.unitTypes.includes(unitType));
  return matches.length > 0 ? matches : templateCatalog;
}
